import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
   selector: 'app-form',
   templateUrl: './form.component.html',
   styleUrls: ['./form.component.css'],
   animations: [
      trigger('state', [
         state('collapse', style({ height: 0 })),
         state('expand', style({ height: '*' })),
         transition('collapse => expand', animate('300ms ease-in')),
         transition('expand => collapse', animate('400ms ease-out'))
      ])
   ]
})
export class FormComponent implements OnInit {
   states = ['expand', 'expand'];
   all = 'Collapse All';
   @ViewChild('d0') d0: ElementRef;
   @ViewChild('selector') selector: ElementRef;

   constructor(private renderer: Renderer2) {}

   ngOnInit(): void {
      this.select(this.d0.nativeElement, this.selector.nativeElement);
      setTimeout(() => {
         this.renderer.addClass(this.selector.nativeElement, 'slide');
      }, 500);
   }

   select(div: any, selector: any) {
      selector.style.left = (div.offsetLeft + div.clientWidth / 2 - 12) + 'px';
   }

   toggle(index: number) {
      this.states[index] = this.states[index] === 'collapse' ? 'expand' : 'collapse';
      if (this.states[index] === 'expand') {
         this.all = 'Collapse All';
      } else {
         let collapseAll = true;
         for (let i = 0; i < this.states.length; i++) {
            if (this.states[i] === 'expand') {
               collapseAll = false;
               break;
            }
         }
         this.all = collapseAll ? 'Expand All' : 'Collapse All';
      }
   }

   toggleAll() {
      const s = this.all === 'Collapse All' ? 'collapse' : 'expand';
      for (let i = 0; i < this.states.length; i++) {
         this.states[i] = s;
      }
      this.all = s === 'collapse' ? 'Expand All' : 'Collapse All';
   }
}
